import { render, staticRenderFns } from "./SchemaTable.vue?vue&type=template&id=2f0902a3&scoped=true&"
import script from "./SchemaTable.vue?vue&type=script&lang=js&"
export * from "./SchemaTable.vue?vue&type=script&lang=js&"
import style0 from "./SchemaTable.vue?vue&type=style&index=0&id=2f0902a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0902a3",
  null
  
)

export default component.exports